export default __webpack_public_path__ + "static/media/effect_two.876413ba.svg";